module.exports = __webpack_public_path__ + "img/first-app-title.ad4a8d30.png";